import React, { useState, useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from './ui/button';

const AgeVerificationModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const verified = localStorage.getItem('age_verified');
    if (!verified) {
      setIsOpen(true);
      document.body.style.overflow = 'hidden';
    }
  }, []);

  const handleVerify = (isOver18) => {
    if (isOver18) {
      localStorage.setItem('age_verified', 'true');
      setIsOpen(false);
      document.body.style.overflow = 'auto';
    } else {
      window.location.href = 'https://www.google.com';
    }
  };

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-md"
      data-testid="age-verification-modal"
    >
      <div className="max-w-md w-full mx-4 bg-[#0C0E14] border border-[#1E2532] rounded-2xl p-8 text-center">
        <div className="w-16 h-16 mx-auto mb-6 bg-[#00F0FF]/10 rounded-full flex items-center justify-center">
          <AlertTriangle className="w-8 h-8 text-[#00F0FF]" />
        </div>
        
        <h2 
          className="text-2xl font-bold text-white mb-4"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          Age Verification Required
        </h2>
        
        <p className="text-[#A1A7B5] mb-6">
          This website sells research peptides intended for laboratory and research use only. 
          You must be 21 years or older to enter this site.
        </p>
        
        <p className="text-white font-medium mb-8">
          Are you 21 years of age or older?
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <Button
            onClick={() => handleVerify(true)}
            className="btn-primary flex-1 py-4"
            data-testid="age-verify-yes"
          >
            Yes, I am 21+
          </Button>
          <Button
            onClick={() => handleVerify(false)}
            className="btn-secondary flex-1 py-4"
            data-testid="age-verify-no"
          >
            No, I am under 21
          </Button>
        </div>
        
        <p className="text-[#A1A7B5] text-xs mt-6">
          By clicking "Yes, I am 18+", you confirm that you are of legal age and agree to our Terms of Service.
        </p>
      </div>
    </div>
  );
};

export default AgeVerificationModal;
